export default __webpack_public_path__ + "static/media/markerbold.ec079bac.png";